module.exports = __webpack_public_path__ + "static/bbl-49df297b63dd54b005f6ac17ebcba436.png";